import React, { Component } from 'react';
import {Provider} from 'react-redux';
import axios from 'axios';
import {parseString} from 'xml2js';
import './css/App.css';
import * as actionCreators from './js/actions/actionCreators';
import Root   from './js/components/layout/Root';
import Store  from './js/stores/Store';
import Utils from './js/utils';
import Constants from './js/constants';

class App extends Component {

    fetchData (endpoint){
        axios.all([ 
            this.getAvailabilityData(),
            this.getTakeUpData(), 
            this.getKeyDeals(),
            this.getLocationData(),
            this.getRegionContacts(),
            this.getRegionLocationMapping()

             ]).then((results)=>{
            // This promise is fullfilled when all the requests are completed
            // Store all the results of the request as json objects in apiData
            let apiData = Utils.parseXmlToJson(results , parseString);
            // Dispatch an event when completed
            Store.dispatch( actionCreators.fetchApiData(apiData));
            //console.log('data fetch');
        });
    }

    getTakeUpData (){
        return axios.get(Constants.endpoint + 'xml/take_up.xml');
    }

    getAvailabilityData (){
        return axios.get(Constants.endpoint + 'xml/availability.xml');
    }

    getKeyDeals (){
        return axios.get(Constants.endpoint + 'xml/key_deals.xml');
    }

    getLocationData (){
        return axios.get(Constants.endpoint + 'xml/location_data.xml');
    }

    getRegionContacts (){
        return axios.get(Constants.endpoint + 'xml/region_contacts.xml');
    }

    getRegionLocationMapping (){
        return axios.get(Constants.endpoint + 'xml/region_location_mapping.xml');
    }

    componentWillMount(){
        this.fetchData()
    }

    render() {
        return (
            <Provider store={Store}>
                <Root />
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js